/**
 * 商品詳細ページ: SP スライド中の画像高さ切れを防ぐパッチ
 *
 * テーマ標準の adaptive-height 機能はスクロール停止後（carousel:settle）に
 * maxHeight を更新するため、異なるサイズの画像をスライドしている最中は
 * 前の画像の高さのまま maxHeight が固定される。
 * その結果、次の（より大きい）画像の下部が overflow: hidden によって切れて
 * 一瞬途切れて見える問題が発生する。
 *
 * このスクリプトは scroll イベント中に「画面に部分的でも見えているセル」の
 * 最大高さを取得し、maxHeight をリアルタイムで引き上げることで切れを防ぐ。
 * スクロール停止後はテーマ標準の adaptHeight_fn が正確な値に調整する。
 */
(function () {
  'use strict';

  // SP（999px 以下）のみ適用（PC は adaptive-height の挙動に問題なし）
  var mq = window.matchMedia('(max-width: 999px)');

  /**
   * 指定した scroll-carousel 要素にスクロール中の高さ補正を適用する
   * @param {HTMLElement} carousel - scroll-carousel 要素
   */
  function patchAdaptiveHeight(carousel) {
    if (!carousel.hasAttribute('adaptive-height')) return;

    carousel.addEventListener('scroll', function () {
      if (!mq.matches) return;

      // hidden 属性のないセル（表示対象のスライド）を取得
      var cells = Array.from(carousel.children).filter(function (child) {
        return !child.hasAttribute('hidden');
      });

      var maxH = 0;

      cells.forEach(function (cell) {
        // セルがビューポート内に少しでも入っているか判定
        var cellLeft = cell.offsetLeft;
        var cellRight = cellLeft + cell.offsetWidth;
        var viewLeft = carousel.scrollLeft;
        var viewRight = viewLeft + carousel.clientWidth;

        if (cellRight > viewLeft && cellLeft < viewRight) {
          // 部分的にでも見えているセルの高さを比較
          maxH = Math.max(maxH, cell.clientHeight);
        }
      });

      if (maxH > 0) {
        // スクロール中に必要な最大高さを maxHeight に反映し、切れを防ぐ
        carousel.style.maxHeight = maxH + 'px';
      }
    });
  }

  /**
   * ページ内の対象カルーセルにパッチを適用する
   */
  function init() {
    document.querySelectorAll('scroll-carousel[adaptive-height]').forEach(patchAdaptiveHeight);
  }

  // DOM 構築前後どちらでも安全に実行できるよう分岐
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
